export enum ReportSeriesFacetGeneratorEnum {
    facet,
    dateFacet,
    neoFacet
}
